







































import { PageKey } from '@/types';
import SunEditor from 'suneditor/src/lib/core';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import suneditor from 'suneditor';
import plugins from 'suneditor/src/plugins';
import lang from 'suneditor/src/lang';
import { ButtonListItem } from 'suneditor/src/options';
import {
  plugin_dialog_component_fileManager,
  plugin_dialog_component_videoManager,
} from '@/utils/editorPlugin';

@Component({
  components: {},
})
export default class ProfileFormItem extends Vue {
  VUE_APP_BASE_API = process.env.VUE_APP_BASE_API;
  @Prop({
    type: Array,
    default: () => [],
    required: true,
  })
  data!: PageKey[];

  @Prop({
    type: String,
    default: () => '',
    required: true,
  })
  editingId!: string;

  @Prop({
    type: Function,
    default: () => false,
  })
  hiddenItem: ((key: PageKey) => boolean) | undefined;

  @Prop({
    type: Function,
    default: () => false,
  })
  disabledItem: ((key: PageKey) => boolean) | undefined;

  public editors: Record<string, SunEditor> = {};

  mounted() {
    this.initView();
  }

  @Watch('editingId')
  onDataInit(editingId, old) {
    if (editingId !== old) {
      // 生成文本编辑器
      this.initView();
    }
  }

  initView() {
    const clear = !this.editingId;
    this.data
      .filter((i) => i.type === 'html')
      .forEach((i, index) => {
        if (!this.editors[i.pattern]) {
          setTimeout(() => {
            this.initEditor(i.pattern);
            // set editors value
            this.editors[i.pattern].setContents(clear ? '' : i.value || '');
            this.editors[i.pattern].onInput = (e) => {
              this.$emit('change');
            };
          });
        } else {
          // set editors value
          this.editors[i.pattern].setContents(clear ? '' : i.value || '');
          this.editors[i.pattern].onInput = (e) => {
            this.$emit('change');
          };
        }
      });
    this.$forceUpdate();
  }

  initEditor(id: string) {
    this.editors[id] = suneditor.create(
      document.getElementById('richtext-editor-' + id) || 'richtext-editor-' + id,
      {
        plugins: {
          ...plugins,
          plugin_dialog_component_fileManager,
          plugin_dialog_component_videoManager,
        },
        width: '100%',
        height: '300px',
        buttonList: [
          ['undo', 'redo'],
          ['fontSize', 'formatBlock'],
          ['blockquote'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
          ['fontColor', 'hiliteColor'],
          ['removeFormat'],
          ['outdent', 'indent'],
          ['align', 'horizontalRule', 'list', 'lineHeight'],
          ['table', 'link', 'customImage', 'customVideo'],
          ['codeView'],
          ['fullScreen'],
          ['preview'],
        ] as ButtonListItem[],
        lang: lang.zh_cn,
      },
    );
  }

  handleAvatarSuccess(pattern) {
    return (res, file) => {
      this.$emit('change', { key: pattern, value: res.url });
      this.$forceUpdate();
    };
  }

  onBlur() {
    // console.log('blur');
  }

  // onDateChange(value) {
  //   this.$emit('change', {key:key.pattern, value:$event})
  // }
}
